

const BackButton = ({onClick}: {onClick: () => void}) => {
  return (
    <button
      onClick={onClick}
      className="p-2 hover:bg-slate-200 rounded-xl transition-colors"
    >
      ← Back
    </button>
  );
}

export default BackButton